import { CarePlanApi, PatientsApi } from "patients-experience-client";
import { AxiosInstance } from "axios";
import { createAxiosInstance } from "./tokenAppender";
import { createCommonConfigurationForApis } from "../CommonHelper";
import { LookupApi, WorkflowsApi } from "common-util-experience-client";
import { PgisApi } from "pgi-experience-client";
import { spire360ApiClient } from "../Spire360ApiClient";
import { GridApi } from "grid-experience-client";

export function createPatientApi(): PatientsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = createAxiosInstance(basePath!);
    return new PatientsApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
      // createCommonConfigurationForApis(),
      // "http://localhost:4020"
    );
  } else {
    return new PatientsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
      // "http://localhost:4020"
    );
  }
}

export function createCarePlanApi(): CarePlanApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PATIENTS_API_URL;
    const axiosInstance: AxiosInstance = createAxiosInstance(basePath!);
    return new CarePlanApi(
      undefined,
      `${process.env.REACT_APP_PATIENTS_API_URL_GATEWAY}`,
      axiosInstance,
      // createCommonConfigurationForApis(),
      // "http://localhost:4020"
    );
  } else {
    return new CarePlanApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PATIENTS_API_URL}`,
      // "http://localhost:4020"
    );
  }
}

export function createWorkflowApi(): WorkflowsApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_WORKFLOW_API_URL;
    const axiosInstance: AxiosInstance = createAxiosInstance(basePath!);
    return new WorkflowsApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance,
      // "http://localhost:4070"
    );
  } else {
    return new WorkflowsApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`,
      // "http://localhost:4070"
    );
  }
}

export function createPgiApi(): PgisApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_PGI_API_URL;
    const axiosInstance: AxiosInstance = createAxiosInstance(basePath!);
    return new PgisApi(
      undefined,
      `${process.env.REACT_APP_PGI_API_URL_GATEWAY}`,
      axiosInstance,

      // "http://localhost:4035"
    );
  } else {
    return new PgisApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_PGI_API_URL}`,

      // "http://localhost:4035"
    );
  }
}

export function createCommonUtilsApi(): LookupApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";

  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_LOOKUP_API_URL;
    const axiosInstance: AxiosInstance = createAxiosInstance(basePath!);
    return new LookupApi(
      undefined,
      `${process.env.REACT_APP_COMMONUTILS_API_URL_GATEWAY}`,
      axiosInstance,
    );
  } else {
    return new LookupApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_COMMONUTILS_API_URL}`,
    );
  }
}

export function createGridApi(): GridApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  if (isGatewayEnabled) {
    const basePath = process.env.REACT_APP_GRID_API_URL_GATEWAY;
    const axiosInstance: AxiosInstance = createAxiosInstance(basePath!);
    return new GridApi(undefined, basePath, axiosInstance);
  } else {
    return new GridApi(
      createCommonConfigurationForApis(),
      `${process.env.REACT_APP_GRID_API_URL}`,

      // "http://localhost:4000"
    );
  }
}

export async function downloadCarePlanPdf(
  careplanId: string,
): Promise<string | null> {
  try {
    console.log("downloading care plan with new function!");
    const apiClient = spire360ApiClient;

    const response = await apiClient.post(
      `${process.env.REACT_APP_CARE_PLAN_DOWNLOAD_API_URL}`,
      {
        url: `${process.env.REACT_APP_WEB_BASE_URL}/careplan/${careplanId}`,
        carePlanId: careplanId,
      },
    );

    const { fileKey } = response.data;
    return fileKey || null;
  } catch (error: any) {
    console.error("Error generating PDF:", error);
    return null;
  }
}
